import React from 'react'
    const userAgent = navigator.userAgent

    export const getDeviceType = () => {
        if (/android/i.test(userAgent)) {
            return 1;
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 1;
        }
        // Check for desktop
        if (/Macintosh|Windows|Linux/.test(userAgent)) {
            return 1;
        }
        return "Unknown";
    }

    export const getOSType = () => {
        if (/Windows NT 10.0/.test(userAgent)) return "Windows 10";
        if (/Windows NT 6.2/.test(userAgent)) return "Windows 8";
        if (/Windows NT 6.1/.test(userAgent)) return "Windows 7";
        if (/Windows NT 6.0/.test(userAgent)) return "Windows Vista";
        if (/Windows NT 5.1/.test(userAgent)) return "Windows XP";
        if (/Mac/.test(userAgent)) return "MacOS";
        if (/X11/.test(userAgent)) return "UNIX";
        if (/Linux/.test(userAgent)) return "Linux";
        if (/Android/.test(userAgent)) return "Android";
        if (/iPhone|iPad|iPod/.test(userAgent)) return "iOS";

        return "Unknown OS";
    }


    export const getBrowserInfo = () => {
        ;
        let browserName = "Unknown";
        let browserVersion = "Unknown";

        if (userAgent.includes("Firefox")) {
            browserName = "Firefox";
            browserVersion = userAgent.match(/Firefox\/([0-9.]+)/)?.[1];
        } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
            browserName = "Chrome";
            browserVersion = userAgent.match(/Chrome\/([0-9.]+)/)?.[1];
        } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
            browserName = "Safari";
            browserVersion = userAgent.match(/Version\/([0-9.]+)/)?.[1];
        } else if (userAgent.includes("Edg")) {
            browserName = "Edge";
            browserVersion = userAgent.match(/Edg\/([0-9.]+)/)?.[1];
        } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
            browserName = "Opera";
            browserVersion = userAgent.match(/(Opera|OPR)\/([0-9.]+)/)?.[2];
        } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
            browserName = "Internet Explorer";
            browserVersion = userAgent.match(/(MSIE |rv:)([0-9.]+)/)?.[2];
        }

        return {
            browserName,
            browserVersion
        };
    }